import {sendDataLayerEvent} from '../util/analytics';
import {createHubSpotNewsletterForm} from '../util/hubspot-form';

const NEWSLETTER_FORM_ID = '98784659-77bb-4dfb-8102-030014942dee';

// Newsletter form
jQuery(document).ready(function ($) {
  'use strict';
  createHubSpotNewsletterForm(
    NEWSLETTER_FORM_ID,
    '.hs-form__container',
    'btn btn--outline-white subscribe-btn',
    () => sendDataLayerEvent('footerNewsletterSubmitted')
  );
});
